import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { ModalSairSemSalvar } from "@/shared/components/ModalSairSemSalvar";
import type { useProtecaoFormulario } from "@/shared/hooks/useProtecaoSaida";

interface Props {
  titulo: string;
  descricao?: string;
  /** Proteção contra perda de dados (`useProtecaoFormulario()` da página): aviso "Sair sem salvar?". */
  protecao?: ReturnType<typeof useProtecaoFormulario>;
  children: ReactNode;
}

/** Moldura das telas de formulário do elo (mesma largura/estilo das outras páginas). */
export function PaginaFormulario({ titulo, descricao, protecao, children }: Props) {
  return (
    <main className="mx-auto w-full max-w-xl px-4 pb-24 pt-6 sm:px-6 sm:pt-10">
      <header className="mb-5">
        <h1 className="text-2xl font-black tracking-tight text-primary sm:text-3xl">{titulo}</h1>
        {descricao && <p className="mt-1 text-sm text-muted">{descricao}</p>}
      </header>
      {protecao ? <div {...protecao.areaProps}>{children}</div> : children}
      {protecao && (
        <ModalSairSemSalvar
          aberto={protecao.pedindoSaida}
          onSair={protecao.confirmarSaida}
          onContinuar={protecao.continuarEditando}
        />
      )}
    </main>
  );
}

/** Mostrada quando o papel da pessoa não permite aquela tela (o banco recusaria de qualquer forma). */
export function SemPermissao({ texto }: { texto: string }) {
  return (
    <main className="mx-auto w-full max-w-xl px-4 py-10 text-center">
      <p className="text-sm text-muted">{texto}</p>
      <Link
        to="/visitantes"
        className="mt-3 inline-block text-sm font-semibold text-primary underline"
      >
        Voltar para Visitantes
      </Link>
    </main>
  );
}
